import React from "react";

interface IconProps {
  fill?: string;
  height?: string;
}

const Comment: React.FC<IconProps> = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96.25"
    height={props.height || "24px"}
    fill={props.fill || "#000"}
  >
    <title>Cancel</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="cancel_icon">
          <path d="M89.545,15.292l-76,76c-0.977,0.977-2.256,1.465-3.536,1.465s-2.559-0.488-3.536-1.465c-1.953-1.952-1.953-5.118,0-7.07&#10;&#9;l34.465-34.465L6.474,15.292c-1.953-1.953-1.953-5.119,0-7.071c1.954-1.952,5.119-1.951,7.071,0L48.01,42.686L82.475,8.221&#10;&#9;c1.951-1.952,5.119-1.952,7.07,0C91.498,10.173,91.498,13.339,89.545,15.292z M60.982,55.659l-7.07,7.07l28.563,28.563&#10;&#9;c0.976,0.977,2.256,1.465,3.535,1.465s2.56-0.488,3.535-1.465c0.977-0.976,1.465-2.256,1.465-3.535s-0.488-2.56-1.465-3.535&#10;&#9;L60.982,55.659z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Comment;
